import { karachiDateKey } from './date';

export function reservationsForDate(records = [], dateKey = karachiDateKey()) {
  return records.filter(record => record.bookingDate && karachiDateKey(record.bookingDate) === dateKey);
}

export function reservedOnly(records = []) {
  return records.filter(record => record.status === 'reserved');
}

export function byBranch(records = []) {
  return records.reduce((acc, record) => {
    const branch = record.branch || 'Missing Data';
    acc[branch] = acc[branch] || [];
    acc[branch].push(record);
    return acc;
  }, {});
}

export function byReservationStage(records = []) {
  return {
    reservations: records.filter(record => record.actualStage === 'reservations'),
    onfloor: records.filter(record => record.actualStage === 'onfloor'),
    served: records.filter(record => record.actualStage === 'served'),
    noshow: records.filter(record => record.actualStage === 'noshow')
  };
}

export function sumReservedPax(records = []) {
  return records.reduce((sum, record) => sum + Number(record.guestCount || 0), 0);
}

export function sumBillingPax(records = []) {
  return records.reduce((sum, record) => sum + Number(record.billingPax || 0), 0);
}

export function todaySummary(records = [], dateKey = karachiDateKey()) {
  const dayRecords = reservationsForDate(records, dateKey);
  const reserved = reservedOnly(dayRecords);
  const stages = byReservationStage(reserved);
  return {
    dateKey,
    records: dayRecords,
    reserved,
    byBranch: byBranch(reserved),
    stages,
    counts: {
      totalReserved: reserved.length,
      onFloorOrServed: stages.onfloor.length + stages.served.length,
      noShows: stages.noshow.length
    },
    pax: {
      reserved: sumReservedPax(reserved),
      billing: sumBillingPax([...stages.onfloor, ...stages.served]),
      noShow: sumReservedPax(stages.noshow)
    }
  };
}
